import type { ReactNode } from "react";
import { Breadcrumbs } from "./Breadcrumbs";

type PageHeroProps = {
  eyebrow: string;
  title: ReactNode;
  description: string;
  currentPage: string;
  aside?: ReactNode;
  tone?: "light" | "blue" | "green";
};

export function PageHero({ eyebrow, title, description, currentPage, aside, tone = "light" }: PageHeroProps) {
  return (
    <section className={`page-hero page-hero-${tone}`}>
      <div className="page-hero-ring ring-one" aria-hidden="true" />
      <div className="page-hero-ring ring-two" aria-hidden="true" />
      <div className="container">
        <Breadcrumbs items={[{ label: currentPage }]} />
        <div className="page-hero-grid">
          <div className="page-hero-copy">
            <p className="eyebrow"><span /> {eyebrow}</p>
            <h1>{title}</h1>
            <p>{description}</p>
          </div>
          {aside ? <div className="page-hero-aside">{aside}</div> : null}
        </div>
      </div>
    </section>
  );
}
